import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from 'src/app/app.constant';
@Component({
    selector: 'app-order-data-message',
    templateUrl: './order-data-message.component.html',
    styleUrls: ['./order-data-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderDataMessageComponent implements OnInit {

  constructor(private appService: AppService) { }
  @Input() orderData;
  @Input() configData;
  @Input() orderType;
  @Input() orderId;
  finalActionRequiredList;
  escalatedTo;
  holdStatus;
  holdReleaseDate;
  holdReason;
  status;
  offsite;

  ngOnInit() {        
    this.getOrderData(this.orderType);    
  }

  getOrderData(data) {
    const userId = localStorage.getItem('userName');
    const customerCode = localStorage.getItem('customerCode');
    const orderFetchUrl = `${APP_Constants.COX_ORDER_SEARCH_BY_ID}${this.configData}?userId=${userId}&customerCode=${customerCode}&action=fetchOrder`;
  
    this.appService.makeHttpGetRequest(orderFetchUrl).subscribe(response => {
      const rawData = response['data'].businessObject;
      
      if(rawData.additionalDetails_isTrueOffsite == true){
        this.offsite = "Vehicle offsite"
      }
      if (rawData.status == "VerificationOnHold") {
        this.holdStatus = "Future date pickup order"
      } else if (rawData.status == "EnrichmentOnHold") {
        this.holdStatus = "Unit Confirmed Not Ready for Pickup"
      }

      if(rawData.orderDetails_holdReleaseDate){
        this.holdReleaseDate = rawData.orderDetails_holdReleaseDate
      }

      if(rawData.orderDetails_holdReason){
        this.holdReason = rawData.orderDetails_holdReason
      }

      if(rawData.status == "Enriched" || rawData.status == "VerificationInProgress"){
        this.status = "Condition & Availability Response Pending from Pickup Location"
      }
      
      if(rawData.orderDetails_escalatedTo && rawData.orderDetails_escalatedTo != "de-escalate") {
        if (rawData.orderDetails_escalatedTo == "escalate to operations") {
          this.escalatedTo = "Escalated to Operations"
        }else {
          this.escalatedTo = rawData.orderDetails_escalatedTo
        }
      }    

      // the below substatusArray contains list of substatuses of this order order
      const substatusArray = [];
      for (const [key, value] of Object.entries(rawData)) {
        if (key.startsWith("substatus_")) {
          substatusArray.push({ [key]: value });
        }
      }
      const validSubstatuses = [
        "OriginAddressEnriched",
        "DestinationAddressEnriched",
        "ClientEnriched",
        "PayerEnriched",
        "orderauctioncodeEnriched",
        "vinisValid",
        "QuoteIDEnriched",
        "GatepassEnriched",
        "VehicleReleaseGenericEnriched",
        "VehicleReleaseEnriched",
        "GateReleaseEligibleEnriched",
        "contractedchecked",
        "pickupNamePhoneEnrichmentEnriched",
        "dropoffNamePhoneEnrichmentEnriched",
        "StagingLocationEnriched",
        "VehicleDetailsEnriched",
        "VYMMEnriched",
        "EnrichedInventoryTypeEnriched",
        "lessThan100miles",
        "clientActive",
        "payerActive"
      ];
      // the below filter is to get the substatuses which has "enriched false" and it trims the "substatus_"
      const filteredSubstatusArray = substatusArray.filter(item => Object.values(item)[0] !== true)
                                                   .map(item => Object.keys(item)[0].replace("substatus_", ""));
      let actionRequiredList = filteredSubstatusArray.filter(item => validSubstatuses.includes(item));
     
      // the below logic is to set the appropriate messages to the specific substatuses
      this.finalActionRequiredList = actionRequiredList.map(substring => {
        switch (substring) {   
          
          case "OriginAddressEnriched": return `Address Not Found`;
          case "DestinationAddressEnriched": return `Address Not Found`;
          case "ClientEnriched": return `Invalid Client ID`;
          case "PayerEnriched": return `Invalid Payer ID`;
          case "orderauctioncodeEnriched": return `Auction Code missing`;
          case "vinisValid": return `Vin not found`;
          case "QuoteIDEnriched": return `VIN cannot be decoded or rate missing`;
          case "VehicleReleaseGenericEnriched": return `Vehicle release missing`;
          case "VehicleReleaseEnriched": return `Vehicle release missing`;
          case "GateReleaseEligibleEnriched": return `Gate release ineligible`;
          case "GatepassEnriched": return `Gate pass missing`;
          case "contractedchecked": return 'Contracted Carrier check could not be performed';
          case "pickupNamePhoneEnrichmentEnriched": return 'Origination Location missing name or phone number';
          case "dropoffNamePhoneEnrichmentEnriched": return 'Destination Location missing name or phone number';
          case "StagingLocationEnriched": return 'Staging location cannot be found';
          case "VYMMEnriched": return 'Vehicle missing Year, Make or Model';
          case "EnrichedInventoryTypeEnriched": return 'Inventory type missing';
          case "clientActive": return 'Client Credit Hold';
          case "payerActive": return 'Payer Credit Hold';
          case "lessThan100miles": return 'More than 150 miles';


          default: return substring;
        }
      });
    });
  }
}
  
